import { initPostsSectionCursor } from './postsSectionCursor';

export const loadMore = () => {
  class LoadButton {
    constructor(button) {
      this.nextDom = document;
      this.loadBtnElement = button;
      this.loadMoreWrapper = button.closest('.load-more-btn-wrapper');
      this.container = document.querySelector('.latest-section-posts');

      if (button) {
        this.toLoadMore();
        this.loadNextPage();
      }
    }

    async loadNextPage() {
      const next = this.nextDom.querySelector('link[rel="next"]');

      if (next) {
        let url = next.href;

        try {
          const response = await fetch(url);

          if (!response.ok) {
            this.loadMoreWrapper.style.display = 'none';
            return;
          }

          this.nextDom = document.createRange().createContextualFragment(await response.text());
        } catch {
          this.loadMoreWrapper.style.display = 'none';
        }
      } else {
        this.loadMoreWrapper.style.display = 'none';
      }
    }

    toLoadMore() {
      this.loadBtnElement.addEventListener('click', () => {
        this.loadNextPage();

        for (const post of this.nextDom.querySelectorAll('.latest-section-posts .latest-post')) {
          this.container.appendChild(post);
        }

        initPostsSectionCursor();
      });
    }
  }

  const loadMore = () => {
    const btnsLoad = document.querySelectorAll('.load-more-btn');

    if (!btnsLoad.length) {
      return;
    }

    btnsLoad.forEach((btn) => new LoadButton(btn));
  };

  loadMore();
};
